import Vue from 'vue';
import Vuex from 'vuex';
import * as types from './mutation-types';
import {
  getField,
  updateField
} from 'vuex-map-fields';
//import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import _ from 'lodash';

Vue.use(Vuex);


const debug = process.env.NODE_ENV !== 'production';
const baseUrl = 'https://luxuryshopdz.com/api';
//const baseUrl = 'http://localhost:5000/api';
//const imageUrl = 'https://luxuryshopdz.com';
const imageUrl = 'https://bilal.luxuryshopdz.com';
//const baseUrl = 'https://luxuryshopdz.com/api';
// initial state
const state = {
  commandeInfo: {
    firstName: '',
    lastName: '',
    address: '',
    phoneNumber: '',
    billingAdress: '',
    deliveryAddress: '',
    email: '',
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryPhoneNumber: '',
    deliveryWilaya: '',
    wilaya: ''
  },
  user: {
    firstName: '',
    lastName: '',
    address: '',
    phoneNumber: '',
    billingAdress: '',
    deliveryAddress: '',
    email: '',
    deliveryPostalCode :'',
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryPhoneNumber: '',
    deliveryWilaya: '',
    wilaya: ''
  },
  loginInfo: {
    email: '',
    password: '',
    phonenumber :''
  },
  registreInfo: {
    emailregister: '',
    passwordregister: '',
    phonenumberregister :'',
    prenomregister :'',
    nomregister :''
  },
  product: {},
  added: [],
  all: [],
  festina :[],
  festinadepot :[],
  video :[],
  royal :[],
  men: [],
  user:null,
  women: [],
  lastEntries: [],
  lastEntries2: [],
  lastEntriesfestina : [],
  lastEntriesfestinadepot : [],
  lastEntriesref : [],
  lastEntriesvideo : [],
  lastEntriesroyal : [],
  lastEntriespolice : [],
  lastEntriescerruti : [],
  lastEntrieslotus : [],
  lastEntriesversus: [],
  lastEntriesTRUSSARDI: [],
  lastEntriesMONTIGNAC : [],
  lastEntriesarmani: [],
  lastEntriesnautica: [],
   lastEntriesmaserati: [],

   lastEntriesmorellato: [],
    lastEntriestimberland : [],
  lastEntriesMichaelkors: [],
  lastEntriesconnectee : [],
  lastEntriespromo : [],
  lastEntriespromo :[],
  lastEntriesdiesel : [],
  lastEntriesfossil : [],
  totalProduct: 0,
  totalProductfestina :0,
  totalProductfestinadepot :0,
  totalProductref :0,
  totalProductpromo:0,
  totalProductvideo:0,
  totalProductroyal :0,
  totalProductpolice :0,
  totalProductarmani: 0,
  totalProductnautica: 0,
  totalProductmaserati: 0,
  totalProductmorellato: 0,
  totalProducttimberland:0,
  totalProductMichaelkors: 0,
    totalProductconnectee:0,
  totalProductcerruti:0,
  totalProductlotus: 0,
  totalProductversus: 0,
    totalProductTRUSSARDI: 0,
   totalProductMONTIGNAC:0,
  totalProductdiesel:0,
  totalProductfossil:0,
  menCount: 0,
  womenCount: 0,
  statusCode: 0,
  fetchedData: false,
  isAuthenticated: false,
  orderId: 0
};

// getters
const getters = {
  getField,
  orderId: state => state.orderId,
  isAuthenticated: state => state.isAuthenticated,
  totalProduct: state => state.totalProduct,

  totalProductfestina: state => state.totalProductfestina,
  totalProductfestinadepot: state => state.totalProductfestinadepot,
  totalProductref: state => state.totalProductref,
  totalProductpromo: state => state.totalProductpromo,
  totalProductvideo: state => state.totalProductvideo,
  totalProductroyal: state => state.totalProductroyal,
  totalProductpolice: state => state.totalProductpolice,
  totalProductcerruti: state => state.totalProductcerruti,
  totalProductlotus: state => state.totalProductlotus,
  totalProductversus: state => state.totalProductversus,
    totalProductTRUSSARDI: state => state.totalProductTRUSSARDI,
   totalProductMONTIGNAC: state => state.totalProductMONTIGNAC,
  totalProductarmani: state => state.totalProductarmani,
  totalProductnautica: state => state.totalProductnautica,
  totalProductmaserati: state => state.totalProductmaserati,
   totalProductmorellato: state => state.totalProductmorellato,
  totalProducttimberland: state => state.totalProducttimberland,
  totalProductMichaelkors: state => state.totalProductMichaelkors,
   totalProductconnectee: state => state.totalProductconnectee,
  totalProductdiesel: state => state.totalProductdiesel,
  totalProductfossil: state => state.totalProductfossil,
  menCount: state => state.menCount,
  womenCount: state => state.womenCount,
  cartNotification: state => state.showNotification,
  getCommandeInfo: state => state.commandeInfo,
  user : state => state.user,
  allImages: state => {
    return state.all.map(product => {
      return `${imageUrl}/${product.imgUrl}`
    });
  },
  allProducts: state => {
    return state.all.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        annee : article.anneeArticle,
        quantite : article.quantite,

        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  allProductsbourdima: state => {
    return state.all.filter(x=> x.quantite >=3).map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,

        color: article.couleur,
        quantite :article .quantite,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },


  lastProducts: state => {


    return state.lastEntries.filter(x=> x.famille =='F').map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`,
        photo: `${imageUrl}/${article.photo}`
      }

    });



  },
  lastProductspromos: state => {


    return state.lastEntriespromo.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`,
        photo: `${imageUrl}/${article.photo}`
      }

    });



  },
  lastProductsreference: state => {
    return state.lastEntriesreference.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`,
        photo: `${imageUrl}/${article.photo}`
      }
    });
  },
  lastProducts2: state => {


    return state.lastEntries.filter(x =>x.famille =='H').map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        state : article.status,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`,
        photo: `${imageUrl}/${article.photo}`
      }
    });

  },
    lastProducts2: state => {


    return state.lastEntries.filter(x =>x.famille =='H').map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        state : article.status,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`,
        photo: `${imageUrl}/${article.photo}`
      }
    });

  },



  productsfestina: state => {
    return state.lastEntriesfestina.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        quantite :article.quantite,
        annee :article.anneeArticle,

        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productsfestinadepot: state => {
    return state.lastEntriesfestinadepot.map(article => {
      return {
        id: article.reference,

        quantite :article.quantite,
        img: `${imageUrl}/${article.imgUrl}`,
        description: article.discprition,
        waterResiste :article.waterResiste,
        annee :article.anneeArticle,
        typeBracelet :article.typeBracelet,


        famille : article.famille,


        name: article.marque,
        price: article.prixDetail,
                price2: article.prixAchat,


        gender: article.famille,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productsref: state => {
    return state.lastEntriesref.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        quantite :article.quantite,
        annee :article.anneeArticle,

        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productsfestinabourdima: state => {
    return state.lastEntriesfestina.filter(x=> x.quantite >=3).map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        quantite :article .quantite,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        gender: article.famille,
        color: article.couleur,
        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },

  productsvideo: state => {
    return state.lastEntriesvideo.filter(x=>x.quantite>0).map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productsroyal: state => {
    return state.lastEntriesroyal.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productspolice: state => {
    return state.lastEntriespolice.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productsarmani: state => {
    return state.lastEntriesarmani.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        quantite : article.quantite,
        annee : article.anneeArticle,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
   productsnautica: state => {
    return state.lastEntriesnautica.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        quantite : article.quantite,
        annee : article.anneeArticle,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
    productsmaserati: state => {
    return state.lastEntriesmaserati.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        quantite : article.quantite,
        annee : article.anneeArticle,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
    productsmorellato: state => {
    return state.lastEntriesmorellato.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        quantite : article.quantite,
        annee : article.anneeArticle,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
   productstimberland: state => {
    return state.lastEntriestimberland.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        quantite : article.quantite,
        annee : article.anneeArticle,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productsMichaelkors: state => {
    return state.lastEntriesMichaelkors.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        quantite : article.quantite,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
   productsconnectee: state => {
    return state.lastEntriesconnectee.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        quantite : article.quantite,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productscerruti: state => {
    return state.lastEntriescerruti.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productslotus: state => {
    return state.lastEntrieslotus.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
   productsversus: state => {
    return state.lastEntriesversus.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
     productsTRUSSARDI: state => {
    return state.lastEntriesTRUSSARDI.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
    productsMONTIGNAC: state => {
    return state.lastEntriesMONTIGNAC.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille :article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productsdiesel: state => {
    return state.lastEntriesdiesel.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        quantite : article.quantite,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productsfossil: state => {
    return state.lastEntriesfossil.map(article => {
      return {
        id: article.reference,
        famille:article.famille,
        description: article.discprition,
      waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        annee : article.anneeArticle,
        quantite :article.quantite,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  productspromo: state => {
    return state.lastEntriespromo.map(article => {
      return {
        id: article.reference,
        famille:article.famille,
        description: article.discprition,
      waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        name: article.marque,
        price: article.prixDetail,
        gender: article.famille,
        color: article.couleur,
        annee : article.anneeArticle,
        quantite :article.quantite,
        price2 :article.prixAchat,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },
  menProducts: state => {
    return state.men.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet :article.typeBracelet,
        type :article.type,
        color: article.couleur,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },

  womenProducts: state => {
    return state.women.map(article => {
      return {
        id: article.reference,
        description: article.discprition,
        famille : article.famille,
        name: article.marque,
        price: article.prixDetail,
        price2: article.prixAchat,
        gender: article.famille,
        color: article.couleur,
        waterResiste :article.waterResiste,
        tailleCadron :article.tailleCadron,
        typeBracelet : article.typeBracelet,
        type :article.type,

        sales: false,
        discount: 0,
        img: `${imageUrl}/${article.imgUrl}`
      }
    });
  },

  getNumberOfProducts: state => (state.all ? state.all.length : 0),
  cartProducts: state => state.added,
  /*{
    return state.added.map(({
      id,
      quantity
    }) => {
      const product = state.all.find(p => p.reference === id);

      return {
        id: product.reference,
        name: product.marque,
        price: product.prixDetail,
        color: product.couleur,
        img: `${imageUrl}/${product.imgUrl}`,
        quantity
      };
    });
  },*/
  detailProduct: state =>{

    if(state.product.length>0)
    return state.product;
    if(sessionStorage.length>0)
  return JSON.parse(sessionStorage.getItem('product'));


}

};


// actions
const actions = {
  fblogin({
    commit
  }, accessToken) {
    let url = `${baseUrl}/auth/facebooklogin?accessToken=${accessToken}`;
    axios
      .get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      })
      .then(response => {
        if (response.status === 200) {
          localStorage.setItem('auth', JSON.stringify(response.data));
          commit(types.LOGIN, {
            isAuth: true
          });
        } else
          commit(types.LOGIN, {
            isAuth: false
          });
      });
  },

  //////////////////////////////////////
  login({
    commit
  }) {
    let loginurl = `${baseUrl}/auth/login`;
    let data = state.loginInfo;
    axios.post(loginurl, data, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      if (response.status === 200) {
        localStorage.setItem('auth', JSON.stringify(response.data));
        commit(types.LOGIN, {
          isAuth: true
        });
      } else
        commit(types.LOGIN, {
          isAuth: false
        });
    })
  },
  //////////////////////////////////////
  register({
    commit
  }) {
    let registernurl = `${baseUrl}/auth/Register`;
    let data = state.registreInfo;
    axios.post(registernurl, data, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      if (response.status === 200) {
        localStorage.setItem('auth', JSON.stringify(response.data));
        commit(types.REGISTER, {
          isAuth: true
        });
      } else
        commit(types.REGISTER, {
          isAuth: false
        });
    })
  },

  /////////////////////////////
  logout({
    commit
  }) {
    localStorage.removeItem('auth');
    state.loginInfo.email = "";
    state.loginInfo.password = "";
    commit(types.LOGIN, {
      isAuth: false
    });
  },

  ////////////////////////
  loadCart({
    commit
  }) {
    commit(types.LOAD_CART);
  },
  ///////////////////////////
  addToCart({
    commit
  }, product) {
    commit(types.ADD_TO_CART, {
      id: product.id,
      name: product.name,
      color: product.color,
      price: product.price,
      price2: product.price2,
      img: product.img,
      waterResiste :product.waterResiste,
      tailleCadron :product.tailleCadron,
      typeBracelet : product.typeBracelet,
      type :product.type,


    });
  },
  ////////////////////
  lastProduct({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/lastproducts?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCT, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  lastProductpromo({
    commit
  }, {
    limit
  }) {
    //let url = `${baseUrl}/article/lastproductspromo?_limit=${limit}`;
    let url = `${baseUrl}/article/update/${reference}?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTpromo, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  lastProducttotal({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/lastproducts?_limit=${limit}`;
    let url2 = `${baseUrl}/article/lastproducts2?_limit=${limit}`;

    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCT, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
    axios.get(url2, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCT, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },//
  ////////////////////
   ////////////////////
   lastProductreference({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/update/${reference}?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTreference, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },//
  ////////////////////
  lastProduct2({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/lastproducts2?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCT2, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },


  //
  ////////////////////
  lastProductfestina({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsfestina?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTfestina, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  ////////////////////
  lastProductfestinadepot({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsdepot?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTfestinadepot, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  ////////////////////
  lastProductref({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/product/${"mk5354"}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTref, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },

    ////////////////////
    LAST_PRODUCTvideo({
      commit
    }, {
      limit
    }) {
      let url = `${baseUrl}/article/productsvideo?_limit=${limit}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        state.fetchedData = true;
        commit(types.LAST_PRODUCTvideo, {
          response: response.data
        });
      }).catch(error => {
        console.log(error);
        state.fetchedData = false;
      });
    },
  ////////////////////
  lastProductroyal({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsroyal?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTroyal, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
   ////////////////////
   lastProductpolice({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productspolice?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTpolice, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  //
  ////////////////////
  lastProductarmani({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsarmani?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTarmani, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
   ////////////////////
  lastProductnautica({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsnautica?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTnautica, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
    ////////////////////
  lastProductmaserati({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsmaserati?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTmaserati, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
    ////////////////////
  lastProductmorellato({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsmorellato?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTmorellato, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
    ////////////////////
  lastProducttimberland({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productstimberland?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTtimberland, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  //
    ////////////////////
    lastProductMichaelkors({
      commit
    }, {
      limit
    }) {
      let url = `${baseUrl}/article/productsMichaelkors?_limit=${limit}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        state.fetchedData = true;
        commit(types.LAST_PRODUCTMichaelkors, {
          response: response.data
        });
      }).catch(error => {
        console.log(error);
        state.fetchedData = false;
      });
    },
    //
      ////////////////////
    LAST_PRODUCTconnectee({
      commit
    }, {
      limit
    }) {
      let url = `${baseUrl}/article/productsconnectee?_limit=${limit}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        state.fetchedData = true;
        commit(types.LAST_PRODUCTconnectee, {
          response: response.data
        });
      }).catch(error => {
        console.log(error);
        state.fetchedData = false;
      });
    },
     ////////////////////
     lastProductcerruti({
      commit
    }, {
      limit
    }) {
      let url = `${baseUrl}/article/productscerruti?_limit=${limit}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        state.fetchedData = true;
        commit(types.LAST_PRODUCTcerruti, {
          response: response.data
        });
      }).catch(error => {
        console.log(error);
        state.fetchedData = false;
      });
    },
    //
         ////////////////////
         lastProductlotus({
          commit
        }, {
          limit
        }) {
          let url = `${baseUrl}/article/productslotus?_limit=${limit}`;
          axios.get(url, {
            headers: {
              //'Access-Control-Allow-Origin': '*'
            }
          }).then(response => {
            state.fetchedData = true;
            commit(types.LAST_PRODUCTlotus, {
              response: response.data
            });
          }).catch(error => {
            console.log(error);
            state.fetchedData = false;
          });
        },
        //
           ////////////////////
         lastProductversus({
          commit
        }, {
          limit
        }) {
          let url = `${baseUrl}/article/productsversus?_limit=${limit}`;
          axios.get(url, {
            headers: {
              //'Access-Control-Allow-Origin': '*'
            }
          }).then(response => {
            state.fetchedData = true;
            commit(types.LAST_PRODUCTversus, {
              response: response.data
            });
          }).catch(error => {
            console.log(error);
            state.fetchedData = false;
          });
        },
        //
            ////////////////////
         lastProductTRUSSARDI({
          commit
        }, {
          limit
        }) {
          let url = `${baseUrl}/article/productsTRUSSARDI?_limit=${limit}`;
          axios.get(url, {
            headers: {
              //'Access-Control-Allow-Origin': '*'
            }
          }).then(response => {
            state.fetchedData = true;
            commit(types.LAST_PRODUCTTRUSSARDI, {
              response: response.data
            });
          }).catch(error => {
            console.log(error);
            state.fetchedData = false;
          });
        },
        //
            ////////////////////
         lastProductMONTIGNAC({
          commit
        }, {
          limit
        }) {
          let url = `${baseUrl}/article/productsMONTIGNAC?_limit=${limit}`;
          axios.get(url, {
            headers: {
              //'Access-Control-Allow-Origin': '*'
            }
          }).then(response => {
            state.fetchedData = true;
            commit(types.LAST_PRODUCTMONTIGNAC, {
              response: response.data
            });
          }).catch(error => {
            console.log(error);
            state.fetchedData = false;
          });
        },
        //
  lastProductdiesel({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsdiesel?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTdiesel, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  //
  lastProductfossil({
    commit
  }, {
    limit
  }) {
    let url = `${baseUrl}/article/productsfossil?_limit=${limit}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.LAST_PRODUCTfossil, {
        response: response.data
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  //
  user_info({
    commit
  },{
    phoneNumber
  }) {
    let url = `${baseUrl}/commande/user/${phoneNumber}`;
    axios.get(url, {
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      state.fetchedData = true;
      commit(types.USER_INFO, {
        response: response ,
      });
    }).catch(error => {
      console.log(error);
      state.fetchedData = false;
    });
  },
  //////////////////////////////
  fetchData({
    commit
  }, {
    page,
    filter,
    gender
  }) {
    let url = `${baseUrl}/article/products?_page=${page}&gender=${gender}&filter=${filter}`;
    axios.get(url, {
      headers: {
        //'Access-Control-Allow-Origin': '*'
      }
    }).then(response => {
      commit(types.FETCH_DATA, {
        response: response.data,
        gender: gender
      });
    }).catch(error => {
      console.log(error);
    });

  },
    //////////////////////////////
    fetchDatafestina({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsfestina?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTfestina, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
    //////////////////////////////
    fetchDatafestinadepot({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsdepot?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTfestinadepot, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
    //
        //////////////////////////////
        fetchDataref({
          commit
        }, {
          refe
        }) {
          let url = `${baseUrl}/article/product/${refe}`;
          axios.get(url, {
            headers: {
              //'Access-Control-Allow-Origin': '*'
            }
          }).then(response => {
            commit(types.DETAIL_PRODUCT, {
              product: response.data
            });
          }).catch(error => {
            console.log(error);
          });

        },
     //////////////////////////////
     fetchDatapromo({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productspromo?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTpromo, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
      //////////////////////////////
      fetchDatavideo({
        commit
      }, {
        page,
        filter,
        gender
      }) {
        let url = `${baseUrl}/article/productsvideo?_page=${page}&gender=${gender}&filter=${filter}`;
        axios.get(url, {
          headers: {
            //'Access-Control-Allow-Origin': '*'
          }
        }).then(response => {
          commit(types.LAST_PRODUCTvideo, {
            response: response.data,
            gender: gender
          });
        }).catch(error => {
          console.log(error);
        });

      },

    //////////////////////////////
    fetchDataroyal({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsroyal?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTroyal, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
     //////////////////////////////
     fetchDatapolice({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productspolice?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTpolice, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
     //////////////////////////////
    ////////////////////////
    //////////////////////////////
    fetchDataarmani({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsarmani?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTarmani, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

  },
      //////////////////////////////
    fetchDatanautica({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsnautica?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTnautica, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

  },
     //////////////////////////////
    fetchDatamaserati({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsmaserati?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTmaserati, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

  },
     //////////////////////////////
    fetchDatamorellato({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsmorellato?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTmorellato, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

  },
      //////////////////////////////
    fetchDatatimberland({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productstimberland?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTtimberland, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
     //////////////////////////////
     fetchDataMichaelkors({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsMichaelkors?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTMichaelkors, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

  },
      //////////////////////////////
     fetchDataconnectee({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsconnectee?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTconnectee, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
     //////////////////////////////
     fetchDatacerruti({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productscerruti?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTcerruti, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
     //////////////////////////////
     fetchDatalotus({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productslotus?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTlotus, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
    //////////////////////////////
     //////////////////////////////
     fetchDataversus({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsversus?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTversus, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

  },
      //////////////////////////////
     fetchDataTRUSSARDI({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsTRUSSARDI?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTTRUSSARDI, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

  },
       //////////////////////////////
     fetchDataMONTIGNAC({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsMONTIGNAC?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTMONTIGNAC, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
    //////////////////////////////
    fetchDatadiesel({
      commit
    }, {
      page,
      filter,
      gender
    }) {
      let url = `${baseUrl}/article/productsdiesel?_page=${page}&gender=${gender}&filter=${filter}`;
      axios.get(url, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        commit(types.LAST_PRODUCTdiesel, {
          response: response.data,
          gender: gender
        });
      }).catch(error => {
        console.log(error);
      });

    },
       //////////////////////////////
       fetchDatafossil({
        commit
      }, {
        page,
        filter,
        gender
      }) {
        let url = `${baseUrl}/article/productsfossil?_page=${page}&gender=${gender}&filter=${filter}`;
        axios.get(url, {
          headers: {
            //'Access-Control-Allow-Origin': '*'
          }
        }).then(response => {
          commit(types.LAST_PRODUCTfossil, {
            response: response.data,
            gender: gender
          });
        }).catch(error => {
          console.log(error);
        });

      },
  doCommande({
    commit
  }) {
    let url = `${baseUrl}/commande/add/E`;
    if (state.commandeInfo) {
      let commandes = [];
      _.forEach(state.added, (value, key) => {
        commandes.push({
          reference: value.id,
          quantity: value.quantity

        })
      })
      let commande = {
        firstName: state.user.firstName,
        lastName: state.user.lastName,
        phoneNumber: state.user.phoneNumber,
        address: state.user.address,
        email : state.user.email,
        billingAddress: state.user.billingAdress,
        deliveryAddress: state.user.deliveryAddress,
        deliveryFirstName: state.user.deliveryFirstName,
        deliveryLastName: state.user.deliveryLastName,
        deliveryPhoneNumber: state.user.deliveryPhoneNumber,
        deliveryWilaya: state.user.deliveryWilaya,
        commandes: commandes
      };
      axios.post(url, commande, {
        headers: {
          //'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
        if (response.status === 201) {
          state.statusCode = 201;
          state.orderId = response.data.idCommande;
          commit(types.DO_COMMANDE);
        } else {
          console.log(response.status);
        }
      }).catch(error => console.log(error));
    }
  },
  ProductDetail({
    commit
  }, product) {
    commit(types.DETAIL_PRODUCT, {
      product: product
    });

  }, ProductDetail2({
    commit
  }, product) {
    commit(types.DETAIL_PRODUCT, {
      product: product
    });
  },
  clearCart({
    commit
  }) {
    commit(types.CLEAR_CART);
  },
  removeItem({
    commit
  }, product) {
    commit(types.REMOVE_FROM_CART, {
      product: product
    });
  }
};
// mutations
const mutations = {
  updateField,
  [types.LOAD_CART](state) {

    let authCredit = JSON.parse(localStorage.getItem('auth'));
    if (authCredit)
      state.isAuthenticated = true;
    else state.isAuthenticated = false;

    let storedCarts = JSON.parse(localStorage.getItem('carts'));
    if (storedCarts) {
      _.forEach(storedCarts, cart => state.added.push(cart));
    }
  },
  [types.ADD_TO_CART](state, {
    id,
    name,
    color,
    price,
    img
  }) {

    if(name==='promo') if (state.added.filter(p=>p.name==='promo').length!=0) return;
    if(name==='promo1') if (state.added.filter(p=>p.name==='promo1').length!=0) return;

    const record = state.added.find(p => p.id === id);
    if (!record) {
      state.added.push({
        id,
        name,
        color,
        price,
        img,
        quantity: 1
      });
    } else
    {
        record.quantity++;
    }


    //store the current cart in localStorage
    localStorage.setItem('carts', JSON.stringify(state.added));
  },
  [types.FETCH_DATA](state, {
    response,
    gender
  }) {
    switch (gender) {
      //men case
      case "H":
        state.men = response.data;
        state.menCount = response.total;
        break;
      case "F":
        state.women = response.data;
        state.womenCount = response.total;
        break;
      default:
        state.all = response.data;
        state.totalProduct = response.total;
        state.totalProductfestina = response.totalfestina;
        state.totalProductfestinadepot = response.totalProductfestinadepot;

        state.totalProductref = response.totalref;
        state.totalProductpromo = response.totalProductpromo;
        state.totalProductvideo = response.totalProductvideo;
        state.totalProductroyal = response.totalroyal;
        state.totalProductpolice= response.totalpolice;
        state.totalProductdiesel = response.totaldiesel;
        state.totalProductarmani = response.totalarmani;
        state.totalProductnautica = response.totalnautica;
        state.totalProductmaserati = response.totalmaserati;
         state.totalProductmorellato = response.totalmorellato;
        state.totalProducttimberland = response.totaltimberland;
        state.totalProductcerruti = response.totalcerruti;
        state.totalProductlotus = response.totallotus;
        state.totalProductversus = response.totalProductversus;
          state.totalProductTRUSSARDI = response.totalProductTRUSSARDI;
           state.totalProductMONTIGNAC = response.totalProductMONTIGNAC;
        state.totalProductfossil = response.totalfossil;

    }

  },
  [types.DETAIL_PRODUCT](state, {
    product
  }) {
    const detailProduct = {
      id: product.id,
      img: product.img,
      discount: false,
      description: product.description,
      price: product.price,
      price2 : product.price2,
      gender: product.gender,
      name: product.name,
      waterResiste :product.waterResiste,
      tailleCadron :product.tailleCadron,
      typeBracelet :product.typeBracelet,
      type :product.type,
    }
    console.log("detailProduct=" +detailProduct);
    state.product = detailProduct;
    sessionStorage.setItem('product',JSON.stringify(detailProduct));
  },
  [types.CLEAR_CART](state) {
    state.added = [];
    var item = localStorage.getItem('carts');
    if (item)
      localStorage.removeItem('carts');
  },
  [types.REMOVE_FROM_CART](state, {
    product
  }) {
    state.added.splice(state.added.indexOf(product), 1);
    //update localstorage if exist
    let carts = localStorage.getItem('carts');
    if (carts) {
      localStorage.removeItem('carts');
      localStorage.setItem('carts', JSON.stringify(state.added));
    }
  },

  [types.DO_COMMANDE](state) {
    let carts = localStorage.getItem('carts');
    if (carts)
      localStorage.removeItem('carts');

    state.added = [];
    state.commandeInfo = [];
  },
  [types.LAST_PRODUCTreference](state, {
    response
  }) {
    state.lastEntriesreference = response.data
  },
  [types.LAST_PRODUCT](state, {
    response
  }) {
    state.lastEntries = response.data
  },
  [types.LAST_PRODUCT2](state, {
    response
  }) {
    state.lastEntries2 = response.data
  },
  [types.LAST_PRODUCTpromo](state, {
    response
  }){
      state.lastEntriespromo = response.data
  },
  [types.LAST_PRODUCTvideo](state, {
    response
  }){
      state.lastEntriesvideo = response.data
      state.totalProductvideo =response.total
  },
  [types.LAST_PRODUCTroyal](state, {
    response
  }){
      state.lastEntriesroyal = response.data
      state.totalProductroyal =response.total
  }, [types.LAST_PRODUCT](state, {
    response
  }) {
    state.lastEntries = response.data
  },
  [types.LAST_PRODUCTpolice](state, {
    response
  }){
      state.lastEntriespolice = response.data
      state.totalProductpolice =response.total
  }, [types.LAST_PRODUCT](state, {
    response
  }) {
    state.lastEntries = response.data
  },
  [types.LAST_PRODUCTarmani](state, {
    response
  }){
      state.lastEntriesarmani = response.data
      state.totalProductarmani =response.total
  },
  [types.LAST_PRODUCTMichaelkors](state, {
    response
  }){
      state.lastEntriesMichaelkors = response.data
      state.totalProductMichaelkors =response.total
  },
   [types.LAST_PRODUCTnautica](state, {
    response
  }){
      state.lastEntriesnautica = response.data
      state.totalProductnautica =response.total
  },
    [types.LAST_PRODUCTmaserati](state, {
    response
  }){
      state.lastEntriesmaserati = response.data
      state.totalProductmaserati =response.total
  },
    [types.LAST_PRODUCTmorellato](state, {
    response
  }){
      state.lastEntriesmorellato = response.data
      state.totalProductmorellato =response.total
  },
   [types.LAST_PRODUCTtimberland](state, {
    response
  }){
      state.lastEntriestimberland = response.data
      state.totalProducttimberland =response.total
  },
  [types.LAST_PRODUCTMichaelkors](state, {
    response
  }){
      state.lastEntriesMichaelkors = response.data
      state.totalProductMichaelkors =response.total
  },
   [types.LAST_PRODUCTconnectee](state, {
    response
  }){
      state.lastEntriesconnectee = response.data
      state.totalProductconnectee =response.total
  },
  [types.LAST_PRODUCTcerruti](state, {
    response
  }){
      state.lastEntriescerruti = response.data
      state.totalProductcerruti =response.total
  },
  [types.LAST_PRODUCTlotus](state, {
    response
  }){
      state.lastEntrieslotus = response.data
      state.totalProductlotus =response.total
  }, [types.LAST_PRODUCTfestina](state, {
    response
  }){
      state.lastEntriesfestina = response.data
      state.totalProductfestina =response.total
  },
  [types.LAST_PRODUCTTRUSSARDI](state, {
    response
  }){
      state.lastEntriesTRUSSARDI = response.data
      state.totalProductTRUSSARDI =response.total
  },
  [types.LAST_PRODUCTversus](state, {
    response
  }){
      state.lastEntriesversus = response.data
      state.totalProductversus =response.total
  }, [types.LAST_PRODUCTfestina](state, {
    response
  }){
      state.lastEntriesfestina = response.data
      state.totalProductfestina =response.total
  },
   [types.LAST_PRODUCTMONTIGNAC](state, {
    response
  }){
      state.lastEntriesMONTIGNAC = response.data
      state.totalProductMONTIGNAC =response.total
  }, [types.LAST_PRODUCTfestina](state, {
    response
  }){
      state.lastEntriesfestina = response.data
      state.totalProductfestina =response.total
  },
  [types.LAST_PRODUCTfestinadepot](state, {
    response
  }){
      state.lastEntriesfestinadepot = response.data
      state.totalProductfestinadepot =response.total
  },
 [types.LAST_PRODUCTref](state, {
    response
  }){
      state.lastEntriesref = response.data
      state.totalProductref =response.total
  },
  [types.LAST_PRODUCTpromo](state, {
    response
  }){
      state.lastEntriespromo = response.data
      state.totalProductpromo =response.total
  },
  [types.LAST_PRODUCTdiesel](state, {
    response
  }){
      state.lastEntriesdiesel = response.data
      state.totalProductdiesel =response.total
  },[types.USER_INFO](state, {
    response
  }) {
    state.user = response.data
  },
  [types.LAST_PRODUCTfossil](state, {
    response
  }){
      state.lastEntriesfossil = response.data
      state.totalProductfossil =response.total
  },[types.USER_INFO](state, {
    response
  }) {
    state.user = response.data
  },
  [types.LOGIN](state, {
    isAuth
  }) {
    state.isAuthenticated = isAuth
  },
  [types.REGISTER](state, {
    isAuth
  }) {
    state.isAuthenticated = isAuth
  }

};

// one store for entire application
export default new Vuex.Store({
  state,
  //strict: debug,
  getters,
  actions,
  mutations
  /*plugins: [createPersistedState({
    //storage: window.sessionStorage //if change to localStorage replace evrey sessionStorage in this file
  })]*/
});




// WEBPACK FOOTER //
// ./src/store/index.js